import { ResetPasswordForm } from '@/features/auth';

export default function ResetPasswordPage() {
  return <ResetPasswordForm />;
}
